import type { NoteTemplate } from "@/common/types/notesTemplates";
import { toast } from "@/hooks/use-toast";
import {
  useUpdateTemplateFactory,
  type UseUpdateTemplateType,
} from "@/hooks/notesTemplates/useUpdateTemplateFactory";
import { t } from "i18next";
import { useEffect } from "react";
import { CardContentTemplate } from "./CardContentTemplate";

interface Props {
  file: NoteTemplate;
  type: UseUpdateTemplateType;
  refresh: () => void;
}

export const CardContentTemplateUpdate = ({
  file,
  type,
  refresh,
}: Props): React.ReactNode => {
  const { updateTemplate, result, loading, error } =
    useUpdateTemplateFactory(type);

  const handleSave = async (value: string): Promise<void> => {
    await updateTemplate({ result: value, id: file.id });
  };

  useEffect(() => {
    if (!loading) {
      if (error) {
        toast({
          variant: "error",
          title: t("visit.messages.updateFailed"),
        });
      }
      if (result) {
        toast({
          variant: "success",
          title: t("visit.messages.updateSuccessful"),
        });
        refresh();
      }
    }
  }, [error, loading, result, refresh]);

  return (
    <CardContentTemplate file={file} loading={loading} onSave={handleSave} />
  );
};
